<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
                    <v-col cols="12" md="3" lg="3" xl="4" class="mx-0 px-0 mr-md-2 py-lg-0">
						<alternativeAutocompleteOne
                            :items="suppliers"
                            :valueInput="supplierId"
                            :loading="supplierLoading"
                           
                            @valueChange="(v) => {supplierId = v}"
                            @onChange="(v) => {index()}"
                           
                            :label="'Proveedor'"
                            classesContainer="width-auto"
                        ></alternativeAutocompleteOne>
					</v-col>
					
                   
					<v-spacer></v-spacer>
					<v-col  cols="12" md="4" lg="4" class="mx-0 pt-md-0 pt-6 pb-4 pb-md-1">
                        <v-row justify="end">
                            <iconButton :props="pdfBtnData" class="mr-2 mr-md-2 mb-3 mb-md-0">
                                <template slot="imgIcon">
                                    <img :src="pdfIcon" width="24" :class="pdfBtnData.disabled ? `filter-grey` : `filter-grey-darken-3`">
                                </template>
                            </iconButton>
                            <iconButton :props="exportBtnData"></iconButton>
                        </v-row>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="mx-0 px-0">
						<v-card class="index-card">
                            <v-card-title class="body-1 font-weight-bold">
                                <v-col>
                                    <v-row class="primary">
                                        <v-col class="py-1 pb-0 text-sm-start text-center">
                                            <span>MXN:</span>
                                        </v-col>
                                        <v-col class="py-1 pb-0 text-sm-end text-center">
                                           
                                                <span>{{totalReport.mxn}}</span>
                                            
                                        </v-col>
                                    </v-row>
                                    <v-row class="primary">
                                        <v-col class="pt-0 pb-1 text-sm-start text-center">
                                            <span>USD:</span>
                                        </v-col>
                                        <v-col class="pt-0 pb-1 text-sm-end text-center">
                                           
                                                <span>{{totalReport.usd}}</span>
                                            
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-card-title>
                            <v-card-text >
                                <datatable :options="options" :props="tableProps" @methodHandler="method_handler" @handleOptions="handleOptions">
                           
                                </datatable>
                            </v-card-text>
                        </v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

     
	</div>
</template>
<script>
import pdfIcon from '../../../assets/pdf_icon_2.svg';
import Utils from '../../../helpers/Utils';
import PageStateManager from '../../../helpers/PageStateManager';
export default {
    data(){
		return {
            pdfIcon: pdfIcon,
            options: JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable'))??{},
            total: 10,
			search: '',
            selectedID: '',
            totalReport: {mxn: '$0.00', usd: '$0.00'},
           
            supplierLoading: false,
            supplierId: PageStateManager.getState(this.$router.history.current.path, 'supplierId')??'',
            suppliers: [],
			serverErrors: {},
			tableProps: {
				headers: [
					{
						text: 'Factura',
						align: 'left',
						value: 'folio',
						
						class: 'table-b-border black--text'
					},
                    {
						text: 'Referencia',
						align: 'left',
						value: 'reference_name',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Cuenta',
						align: 'center',
						value: 'account_name',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Fecha de factura',
						align: 'center',
						value: 'bill_date',
                        
						class: 'table-b-border black--text'
					},
                    {
						text: 'Fecha de pago',
						align: 'center',
                        
						value: 'payment_date',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Semana',
						align: 'center',
						value: 'week_number',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Concepto',
						align: 'center',
                        
						value: 'concept',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Monto',
						align: 'right',
                        
						value: 'amount',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Divisa',
						align: 'center',
                        
						value: 'currency',
						class: 'table-b-border black--text'
					},
					
				],
				items: [],
				search: '',
				loading: false,
                elevation: '0'
			},
			
			
            exportBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar excel',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-microsoft-excel",
                iconClass: "",
				to: "",
				block: false,
                loading:false,
                click: ()=>{this.export();}
            },
            pdfBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar PDF',
                customIcon:true,
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-progress-download",
                iconClass: "",
				to: "",
				block: false,
                loading: false,
               
                click: ()=>{this.pdf();}
            },

			
		}
	},
    watch: {
        
        [`supplierId`]: function () {
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'supplierId', this.supplierId);
            
        },
    },

	mounted(){
		this.index();
        this.getSuppliers();
        // window.addEventListener('resize', this.onResize, { passive: true });
        // this.onResize();
	},

    methods: {
        onResize () {
            
            if(window.innerWidth <= 960){
                this.exportBtnData.block = true;
                this.pdfBtnData.block = true;
                
            }
            else{
                
                this.exportBtnData.block = false;
                this.pdfBtnData.block = false;
            }
        },

       
        method_handler(object){
			this[object.methodName](object.parameters)
		},
        handleOptions(object){
            object.options[`search`] = this.tableProps.search;
			this.options = object.options;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options));
			// this.index();
		},
        trySearch(val){
            this.tableProps.search = val;
            this.options.page = 1;
            // this.index();
        },
		index() {
            console.log(this.supplierId)
            if(this.supplierId == undefined || this.supplierId == '')
                return;
            
           
			this.tableProps.loading = true;
            this.totalReport.mxn = this.totalReport.usd = Utils.currencyFormat(0, '');
            this.tableProps.items = [];
			//call api
			this.$api.report.reportPaymentHistoryBySupplier(this.$store.state.business, this.supplierId)
				.then((resp) =>{
					console.log(resp);
                    this.totalReport.mxn = Utils.currencyFormat(resp.data.total.mxn, '');
                    this.totalReport.usd = Utils.currencyFormat(resp.data.total.usd, '');
					this.tableProps.items = resp.data.data.map((x) => {
						
						x.amount = Utils.currencyFormat(x?.amount??0, '');
                        x.bill_date = Utils.globalDateFormat(x.bill_date);
                        x.payment_date = Utils.globalDateFormat(x.payment_date);
						return x;
					});
                   
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		
		},

        getSuppliers()
        {
            this.supplierLoading = true;
            this.$api.supplier.getSelectSuppliers(this.$store.state.business)
                .then((resp) => {
                    // this.suppliers.push({"text": "Todos", "value": "all"});
                    this.suppliers.push(...resp.data);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.supplierLoading = false;
                })
            ;
        },

        export()
        {
            if(this.supplierId == '')
                return;

            this.exportBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.report.exportReportPaymentHistoryBySupplier(this.$store.state.business, this.supplierId)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `payment_history_${this.supplierId}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.exportBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },

        pdf()
        {
            if(this.supplierId == '')
                return;

            this.pdfBtnData.loading = true;
            this.$store.state.loading = true;
            this.$api.report.pdfReportPaymentHistoryBySupplier(this.$store.state.business, this.supplierId)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `payment_history_${this.supplierId}.pdf`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.pdfBtnData.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        }

    }
}
</script>